import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: "1px solid #0a0a0a",
                        background: "#0a0a0a",
                        color: "#fff",
                        fontFamily: "IBM Plex Mono, monospace",
                        letterSpacing: "0.05em",
                    },
                }}
            />
        </div>
    );
}

export default App;
